import { useCallback, useRef } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useFunnel } from '@zep/react';
import { CreateSpaceAnalyticsEvents, EmptyTemplateConstants } from '@zep/types';
import { useCreateSpace } from './hooks';
import { MapTemplateModal, MapTemplateModalProps } from './MapTemplateModal';
import { CreateSpaceSchemaType } from './schema';
import { SpaceCreateSettingModal } from './SpaceCreateSettingModal';
interface CreateSpaceFunnelProps {
  from?: 'home' | 'play';
}
const CreateSpaceFunnelInner = ({
  from = 'home'
}: CreateSpaceFunnelProps) => {
  const [Funnel, {
    mapTemplate
  }, setFunnelState] = useFunnel(['map-template', 'space-setting']).withState<CreateSpaceFunnelState>({});
  const modal = useModal();
  const mapTemplateStateRef = useRef({
    filterType: 'official' as 'official' | 'purchased',
    filterCategoryId: -1,
    scrollPosition: 0
  });
  const updateMapTemplateState = useCallback((updates: {
    filterType?: 'official' | 'purchased';
    filterCategoryId?: number;
    scrollPosition?: number;
  }) => {
    mapTemplateStateRef.current = {
      ...mapTemplateStateRef.current,
      ...updates
    };
  }, []);
  const {
    createSpace,
    isLoading
  } = useCreateSpace({
    analyticsEvent: CreateSpaceAnalyticsEvents[from],
    place: 'play',
    onSuccess: (_, entryMapHashId) => {
      const url = `/play/${entryMapHashId}`;
      window.open(url, '_blank', 'noopener,noreferrer');
      modal.hide();
    }
  });
  const setTemplate: MapTemplateModalProps['onSelectTemplate'] = template => {
    setFunnelState({
      step: 'space-setting',
      mapTemplate: template
    });
  };
  const handleCreateSpace = async (data: CreateSpaceSchemaType) => {
    const templateHashId = mapTemplate?.hashId ?? EmptyTemplateConstants.hashId;
    const template = {
      hashId: templateHashId,
      name: mapTemplate?.name ?? '빈맵',
      isPurchased: mapTemplate?.isPurchased ?? false
    };
    await createSpace(data, template);
  };
  return <Funnel data-sentry-element="Funnel" data-sentry-component="CreateSpaceFunnelInner" data-sentry-source-file="CreateSpaceFunnel.tsx">
      <Funnel.Step name="map-template" data-sentry-element="unknown" data-sentry-source-file="CreateSpaceFunnel.tsx">
        <MapTemplateModal onSelectTemplate={setTemplate} initialState={mapTemplateStateRef.current} onStateChange={updateMapTemplateState} data-sentry-element="MapTemplateModal" data-sentry-source-file="CreateSpaceFunnel.tsx" />
      </Funnel.Step>
      <Funnel.Step name="space-setting" data-sentry-element="unknown" data-sentry-source-file="CreateSpaceFunnel.tsx">
        <SpaceCreateSettingModal isLoading={isLoading} onSubmit={handleCreateSpace} onBack={() => setFunnelState({
        step: 'map-template'
      })} selectedTemplate={mapTemplate ? {
        name: mapTemplate.name,
        thumbnailUrl: mapTemplate.thumbnailUrl,
        categories: mapTemplate.categories
      } : undefined} data-sentry-element="SpaceCreateSettingModal" data-sentry-source-file="CreateSpaceFunnel.tsx" />
      </Funnel.Step>
    </Funnel>;
};
type CreateSpaceFunnelState = {
  mapTemplate?: Parameters<MapTemplateModalProps['onSelectTemplate']>[0];
};
export const CreateSpaceFunnel = NiceModal.create<CreateSpaceFunnelProps>(CreateSpaceFunnelInner);